import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material";
import { Component, OnInit, Inject } from '@angular/core';


@Component({
  selector: 'app-configurationConfirmationModal',
  templateUrl: '../templates/confirmationModal.component.html'
})
export class ConfirmationModalComponent implements OnInit {
  errorMessage: string;
  currentKey: string;
  operation: string;

  constructor(private dialogRef: MatDialogRef<ConfirmationModalComponent>, @Inject(MAT_DIALOG_DATA) data) {
      this.currentKey = data.Key;
      this.operation = data.Operation;
  }

  ngOnInit() {
    
  }

  updateValue() {
    this.dialogRef.close(true);
  }

  close() {
    this.dialogRef.close(false);
  }
}


// WEBPACK FOOTER //
// ./src/app/configuration/components/scripts/confirmationModal.component.ts